import { BeachIcon } from './BeachIcon';

/**
 * author: Austin Andrews
 * id FB1FEB37-FA9B-40BF-A7EC-B4A1690E6B77
 * name beach
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/beach.svg
 * tags
 * - Places 
 */
export const ParasolIcon = BeachIcon;
export default ParasolIcon